import {
	useEffect,
	useState,
} from 'react';
import TransportList from './components/card/TransportList';
import TransportFilter from './components/filter/transport/TransportFilter';
import DatePickerPlaceHolder from 'components/datepicker/DatePickerPlaceHolder';
import {
	useDebounced, useInterval,
} from 'hooks';
import {
	useAuthService,
	useTripService,
} from 'services'
import {
	getEndOfDay, getStartOfDay,
} from 'utils/time/time.util';
import {
	useLiveQuery,
} from 'dexie-react-hooks';
import {
	AssignmentFilterType,
} from 'utils/transport';
import {
	Assignment, DangerousGoodsModel,
} from 'models';
import './transport.scss';
import {
	useDeviationService,
} from './components/card/modals/deviations/useDeviationService';

const HomePage = () => {
	const [chosenDate, setChosenDate] = useState<Date | null>(null);
	const [filters, setFilters] = useState<AssignmentFilterType>(AssignmentFilterType.ALL);
	const {
		database,
		get,
		isLoading,
	} = useTripService();
	const {
		getByTransportId,
	} = useDeviationService();
	const [isRefreshing, setIsRefreshing] = useState(false);
	const {
		isAuthenticated,
	} = useAuthService();

	const assignments = useLiveQuery(() => {
		const date = chosenDate || new Date();
		const start = getStartOfDay(date).toJSON();
		const end = getEndOfDay(date).toJSON();

		return database.assignments.where('date')
			.between(start, end, true, true)
			.toArray()
	}, [chosenDate]);
	const [assignmentsMapped, setAssignmentsMapped] = useState<Assignment[]>([]);

	const loadRouteAndAssignments = (callback?: () => void) => {
		if (!chosenDate) {
			return;
		}
		if (chosenDate) {
			get(chosenDate)
				.then(list => {
					list.forEach(assignment => getByTransportId(assignment.id));

					if (callback) {
						callback();
					}
				}).catch(console.error);
		}
	}

	const loadDebouncedAssignments = useDebounced(() => {
		loadRouteAndAssignments();
	}, 200);

	useInterval(() => {
		if (!document.hidden) {
			setIsRefreshing(true)
			loadRouteAndAssignments(() => setIsRefreshing(false));
		}
	}, 30_000);

	useEffect(() => {
		if (isAuthenticated && chosenDate != null && loadDebouncedAssignments) {
			loadDebouncedAssignments();
		}
	}, [loadDebouncedAssignments, chosenDate, isAuthenticated]);


	useEffect(() => {
		const result = (assignments || []).map(assignment => {
			 return {
				...assignment,
				goods: {
					...assignment.goods,
					dangerousGoods: assignment.goods?.dangerousGoods ?
						new DangerousGoodsModel().fromJSON(assignment.goods.dangerousGoods) : undefined,
				},
			}
		});
		setAssignmentsMapped(result);
	}, [assignments]);

	return (
		<div style={{
			paddingLeft: '.75rem',
			paddingRight: '.75rem',
		}}>
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				padding: '10px 0',
			}}>
				<TransportFilter onSelection={val => setFilters(val)} />
			</div>

			<div>
				<DatePickerPlaceHolder onChange={date => {
					setChosenDate(date);
				}}/>
			</div>

			<TransportList
				datas={assignmentsMapped}
				filter={filters}
				isLoading={isLoading && !isRefreshing}
			/>
		</div>
	);
}

export default HomePage;